<agm-map
  id="map"
  #map
  d="map"
  [class.dashboard-tooltip-map]="isDashboardTooltip()"
  [height]="height"
  [width]="width"
  [latitude]="lat"
  [longitude]="lng"
  [restriction]="mapRestriction"
  [zoom]="zoom"
  [minZoom]="5"
  [maxZoom]="18"
  [streetViewControl]="false"
  [disableDefaultUI]="true"
  [mapTypeControl]="false"
  [mapTypeId]="'hybrid'"
  (mapReady)="onMapReady($event)"
  (zoomChange)="changeZoom($event)"
  (mapClick)="mapClick($event)"
>
  <ng-container *ngIf="map_scope">
    <agm-polyline *ngFor="let pond of map_scope.farm.ponds">
      <agm-polygon
        *ngIf="pond && pond.coordinates"
        [paths]="pond.coordinates"
        [strokeColor]="pond.count_waterwises > 0 || pond.count_feeders > 0 ? colors.high_success : colors.high_danger"
        [fillOpacity]="0.2"
        (polyClick)="onPolygonScopeClick($event,pond)"
      >
        <agm-marker
          [iconUrl]="transparent"
          [label]="{ color: 'white', text: pond?.name}"
          [latitude]="centerPolygon(pond.coordinates).lat"
          [longitude]="centerPolygon(pond.coordinates).lng"
        >
          <agm-info-window
            [disableAutoPan]="true"
            [isOpen]="pond_selected && show_info_scope && pond_selected.name === pond.name"
          >
            <div style="width: 100px">
              <div class="flex-column text-center gap-10">
                <h4 class="m-0">{{pond.hectares}}h</h4>
                <p class="m-0" *ngIf="pond.count_feeders > 0">
                  {{pond.count_feeders}} Alimentadores
                </p>
                <p class="m-0" *ngIf="pond.count_waterwises > 0">
                  {{pond.count_waterwises}} waterwise
                </p>
              </div>
            </div>
          </agm-info-window>
        </agm-marker>
      </agm-polygon>
    </agm-polyline>
  </ng-container>

  <ng-container *ngIf="farm && farm.coordinates">
    <agm-polygon
      [paths]="farm.coordinates"
      [strokeColor]="'#FFFFFF'"
      [clickable]="!isDashboardTooltip()"
      (polyClick)="clickPolygon($event,farm)"
    >
    </agm-polygon>
  </ng-container>

  <ng-container *ngIf="farms && farms.length > 0">
    <div *ngFor="let farm of farms">
      <agm-polygon
        [paths]="farm.coordinates"
        [strokeColor]="'#FFFFFF'"
        (polyClick)="clickPolygon($event,farms)"
      >
      </agm-polygon>
    </div>
  </ng-container>

  <ng-container *ngIf="list_polygon_with_feeders && list_polygon_with_feeders.length > 0">
    <agm-polyline
      *ngFor="let item of list_polygon_with_feeders"
      [strokeColor]="validateColor(item, 'line')"
    >
      <agm-polygon
        *ngIf="item && item.coordinates"
        [paths]="item.coordinates"
        [strokeColor]="validateColor(item, 'line')"
        (polyClick)="clickPolygon($event,item)"
        [fillColor]="validateColor(item, 'inside')"
        [fillOpacity]="0.2"
      >
        <agm-marker
          [iconUrl]="item.map_icon ? item.map_icon : transparent"
          [label]="item.map_icon ? '' : { color: 'white', text: item?.name }"
          (markerClick)="clickMarkerPolygon($event, item)"
          [openInfoWindow]="false"
          [latitude]="centerPolygon(item.coordinates).lat"
          [longitude]="centerPolygon(item.coordinates).lng"
          [markerDraggable]="false"
        >
          <agm-info-window
            *ngIf="isDashboardTooltip()"
            [disableAutoPan]="false"
            [isOpen]="dashboard_selected === item"
            (infoWindowClose)="onDashboardInfoWindowClose(item)"
          >
            <div class="dashboard-map-tooltip">
              <div class="title">
                <p class="m-0">{{ item.name }}</p>
                <app-image-color
                  [height]="'20px'"
                  [width]="'20px'"
                  [url]="getDashboardIcon()"
                  [color]="'#204349'"
                ></app-image-color>
              </div>

              <div class="card-item">
                <div class="card-item__icon">
                  <app-image-color
                    [height]="'18px'"
                    [width]="'12px'"
                    [url]="'menu-icons/feeders_2.svg'"
                    [color]="'#ffffff'"
                  ></app-image-color>
                </div>
                <span class="card-item__label">
                  {{ "admin.home.map.feeders-alerted" | translate }}
                </span>
                <span class="card-item__value">
                  {{ item.feeder_alerted }}/{{ item.feeder_total }}
                </span>
              </div>

              <div class="card-item">
                <div class="card-item__icon">
                  <app-image-color
                    [height]="'18px'"
                    [width]="'18px'"
                    [url]="'menu-icons/waterwise.svg'"
                    [color]="'#ffffff'"
                  ></app-image-color>
                </div>
                <span class="card-item__label">
                  {{ "admin.home.map.waterwises-alerted" | translate }}
                </span>
                <span class="card-item__value">
                  {{ item.waterwise_alerted }}/{{ item.waterwise_total }}
                </span>
              </div>

              <ng-container *ngIf="type_info_window === 'dashboard_farm'">
                <div class="card-item">
                  <div class="card-item__icon">
                    <app-image-color
                      [height]="'15px'"
                      [width]="'18px'"
                      [url]="'custom_icons/ponds.svg'"
                      [color]="'#ffffff'"
                    ></app-image-color>
                  </div>
                  <span class="card-item__label">
                    {{ "admin.home.map.total-ponds" | translate }}
                  </span>
                  <span class="card-item__value">{{ item.total_ponds }}</span>
                </div>

                <ng-container *ngIf="item.active_cycles && item.active_cycles.length > 0">
                  <div class="card-item">
                    <div class="card-item__icon">
                      <app-image-color
                        [height]="'18px'"
                        [width]="'18px'"
                        [url]="'menu-icons/sows.svg'"
                        [color]="'#ffffff'"
                      ></app-image-color>
                    </div>
                    <span class="card-item__label">
                      {{ "admin.home.map.active-cycles" | translate }}
                    </span>
                    <span class="card-item__value">{{ item.active_cycles.length }}</span>
                  </div>

                  <div class="cycle-item" *ngFor="let cycle of item.active_cycles">
                    <span>{{ cycle.name }}</span>
                    <span
                      >{{ cycle.days_remaining }} {{ "admin.home.map.days-remaining" | translate
                      }}</span
                    >
                  </div>
                </ng-container>
              </ng-container>

              <div class="actions">
                <button
                  type="button"
                  class="btn btn-warning btn-sm"
                  (click)="clickDashboardAlerts.emit(item)"
                >
                  {{ "admin.home.map.alerts-button" | translate }}
                  <em class="fa fa-exclamation-triangle ml-1"></em>
                </button>
                <ng-container *ngIf="type_info_window === 'dashboard_farm'">
                  <button
                    type="button"
                    class="btn btn-primary btn-sm"
                    (click)="clickDashboardNavigate.emit(item)"
                  >
                    {{ "admin.home.map.navigate-button" | translate }}
                    <em class="fa fa-map-marker ml-1"></em>
                  </button>
                  <button
                    type="button"
                    class="btn btn-success btn-sm"
                    (click)="clickDashboardOpen.emit(item)"
                  >
                    {{ "admin.home.map.open-button" | translate }}
                    <em class="fa fa-expand ml-1"></em>
                  </button>
                </ng-container>
              </div>
            </div>
          </agm-info-window>
        </agm-marker>
      </agm-polygon>
      <ng-container *ngIf="item && item.linked_feeders && !view_markers">
        <app-markers-map
          *ngFor="let feeder of item.linked_feeders"
          [feeder]="feeder"
          [reload]="check_feeder_reload"
          [type]="type_info_window"
          (clickFeederAlert)="onClickFeederActionAlert($event)"
          (clickButtonActionSensor)="onClickFeederAction($event)"
        ></app-markers-map>
      </ng-container>
    </agm-polyline>
  </ng-container>

  <ng-container *ngIf="ponds_coordinates && ponds_coordinates.length > 0">
    <agm-polygon
      [paths]="ponds_coordinates"
      (polyClick)="clickPolygon($event)"
      [strokeColor]="validate_color_ponds(feeders, 'line')"
    >
    </agm-polygon>
  </ng-container>

  <ng-container *ngIf="feeders && feeders.length > 0 && view_markers">
    <div *ngFor="let item of feeders">
      <app-markers-map
        [feeder]="item"
        (clickFeederAlert)="onClickFeederActionAlert($event)"
        (clickFeeder)="clickMarker($event)"
      ></app-markers-map>
    </div>
  </ng-container>

  <ng-container *ngIf="list_waterwise && list_waterwise.length > 0 && view_marker_waterwise">
    <div *ngFor="let item of list_waterwise">
      <app-markers-waterwise [waterwise]="item"></app-markers-waterwise>
    </div>
  </ng-container>
  <ng-container *ngIf="feeders_ordering && feeders_ordering.length > 0">
    <div *ngFor="let item of feeders_ordering">
      <app-markers-map
        [feeder]="item"
        (clickFeeder)="clickMarker($event)"
        [type]="type_info_window"
        [draggable]="true"
        (clickButtonActionSensor)="onClickFeederAction($event)"
        (draggableMarker)="dragMarket($event)"
      ></app-markers-map>
    </div>
  </ng-container>

  <ng-container *ngIf="marker && marker.lat !== 0 && marker.lng !== 0">
    <agm-marker
      [latitude]="marker.lat"
      [longitude]="marker.lng"
      [markerDraggable]="true"
      (drag)="dragMarket($event)"
      [iconUrl]="validateIconMarker()"
    >
    </agm-marker>
  </ng-container>
  <ng-container *ngIf="marker_coordinates">
    <agm-polyline [strokeColor]="'red'">
      <ng-container *ngFor="let marker of marker_coordinates; let markerIndex = index">
        <agm-polyline-point
          [latitude]="marker.lat"
          [longitude]="marker.lng"
          *ngIf="type_info_window !== 'waterwise'"
        >
        </agm-polyline-point>
        <agm-marker
          [latitude]="marker.lat"
          [longitude]="marker.lng"
          [opacity]="marker.alpha"
          [markerDraggable]="marker_coordinates_draggable"
          (dragEnd)="onDragMarkerCoordinates($event, markerIndex)"
          [iconUrl]="validateIconMarker()"
        >
        </agm-marker>
      </ng-container>
    </agm-polyline>
  </ng-container>

  <ng-container *ngIf="feeders_gateway">
    <agm-polyline *ngFor="let feeder of feeders_gateway;" [strokeColor]="validateColordb(feeder)">
      <agm-polyline-point [latitude]="feeder.lat" [longitude]="feeder.lng"> </agm-polyline-point>
      <agm-polyline-point
        *ngIf="feeder.gateway && feeder.gateway.installation"
        [latitude]="feeder.gateway.installation.lat"
        [longitude]="feeder.gateway.installation.lng"
      >
      </agm-polyline-point>

      <app-markers-map [feeder]="feeder" [type]="'gateway'"></app-markers-map>

      <app-markers-map [feeder]="feeder" [type]="'feeders_gateway'"></app-markers-map>
    </agm-polyline>
  </ng-container>
</agm-map>
